<script>
export default {
  name: 'Email',
}
</script>

<template>
  <svg
    width="23"
    height="23"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8417 11.8029C13.8417 12.5029 14.0408 12.782 14.5617 12.782C15.7225 12.782 16.4617 11.3029 16.4617 8.84288C16.4617 5.08288 13.7217 3.28288 10.3008 3.28288C6.78167 3.28288 3.58083 5.64288 3.58083 10.1029C3.58083 14.3629 6.38083 16.6829 10.6808 16.6829C12.1408 16.6829 13.1208 16.5229 14.62 16.0229L14.9417 17.362C13.4617 17.8429 11.88 17.982 10.6608 17.982C5.02083 17.982 2 14.882 2 10.102C2 5.28204 5.50083 2.00204 10.3208 2.00204C15.3408 2.00204 18 5.00204 18 8.68204C18 11.802 17.0208 14.182 13.9408 14.182C12.54 14.182 11.6208 13.622 11.5008 12.3812C11.1408 13.7612 10.1808 14.182 8.88 14.182C7.14 14.182 5.68 12.8412 5.68 10.142C5.68 7.42204 6.96083 5.74204 9.26083 5.74204C10.4808 5.74204 11.2408 6.22204 11.5792 6.98204L12.16 5.92204H13.84V11.8029H13.8417ZM11.3825 9.16288C11.3825 8.06371 10.5617 7.60288 9.88167 7.60288C9.14167 7.60288 8.3225 8.20204 8.3225 9.96288C8.3225 11.3629 8.9425 12.1429 9.88167 12.1429C10.5417 12.1429 11.3825 11.7229 11.3825 10.5629V9.16288Z"
      fill="#4B465C"
    />
    <path
      d="M13.8417 11.8029C13.8417 12.5029 14.0408 12.782 14.5617 12.782C15.7225 12.782 16.4617 11.3029 16.4617 8.84288C16.4617 5.08288 13.7217 3.28288 10.3008 3.28288C6.78167 3.28288 3.58083 5.64288 3.58083 10.1029C3.58083 14.3629 6.38083 16.6829 10.6808 16.6829C12.1408 16.6829 13.1208 16.5229 14.62 16.0229L14.9417 17.362C13.4617 17.8429 11.88 17.982 10.6608 17.982C5.02083 17.982 2 14.882 2 10.102C2 5.28204 5.50083 2.00204 10.3208 2.00204C15.3408 2.00204 18 5.00204 18 8.68204C18 11.802 17.0208 14.182 13.9408 14.182C12.54 14.182 11.6208 13.622 11.5008 12.3812C11.1408 13.7612 10.1808 14.182 8.88 14.182C7.14 14.182 5.68 12.8412 5.68 10.142C5.68 7.42204 6.96083 5.74204 9.26083 5.74204C10.4808 5.74204 11.2408 6.22204 11.5792 6.98204L12.16 5.92204H13.84V11.8029H13.8417ZM11.3825 9.16288C11.3825 8.06371 10.5617 7.60288 9.88167 7.60288C9.14167 7.60288 8.3225 8.20204 8.3225 9.96288C8.3225 11.3629 8.9425 12.1429 9.88167 12.1429C10.5417 12.1429 11.3825 11.7229 11.3825 10.5629V9.16288Z"
      fill="white"
      fill-opacity="0.1"
    />
  </svg>
</template>

<style scoped lang="scss">

</style>
